<template>
  <div class="form-group p-r-8" align="left">
    <div class="form-row">
      <div class="form-input cm-select-parent" :class="classes">
        <select
          class="form-control"
          id="expireMonth"
          name="expireMonth"
          :value="value"
          data-test="expire-month-select"
          @input="$emit('input', $event.target.value)"
          @change="$emit('input', $event.target.value)"
        >
          <option value="MM" disabled selected hidden>MM</option>
          <option value="01">01</option>
          <option value="02">02</option>
          <option value="03">03</option>
          <option value="04">04</option>
          <option value="05">05</option>
          <option value="06">06</option>
          <option value="07">07</option>
          <option value="08">08</option>
          <option value="09">09</option>
          <option value="10">10</option>
          <option value="11">11</option>
          <option value="12">12</option>
        </select>
        <label for="expireMonth" data-test="expire-month-label">{{
          $t("paymentdetails.cards.labelExpirationmonth")
        }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "expirationMonth",
  props: ["value", "messages", "flags"],
  computed: {
    classes() {
      if (this.flags.validated && !this.flags.valid) {
        return "error";
      }
      if (this.flags.validated && this.flags.valid) {
        return "success";
      }
      return "";
    },
  },
};
</script>
